import React from 'react';
import { Link } from 'react-router-dom';
import VisitorCounter from './VisitorCounter';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Timepass Game</h3>
            <p>Free online games and tools for entertainment, education, and productivity. Challenge your mind with our collection of puzzles, arcade games, match-3 adventures, and useful digital tools designed for all ages.</p>
            <div className="social-links">
              <span>Follow us for updates!</span>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Games</h4>
            <ul>
              <li><Link to="/country-quiz">Country Quiz</Link></li>
              <li><Link to="/gem-quest">Gem Quest</Link></li>
              <li><Link to="/guess-secret-number">Guess Secret Number</Link></li>
              <li><Link to="/snake-game">Snake Game</Link></li>
              <li><Link to="/tiger-image-shuffle-game">Tiger Puzzle</Link></li>
              <li><Link to="/lions-image-shuffle-game">Lions Puzzle</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Tools</h4>
            <ul>
              <li><Link to="/character-counter">Character Counter</Link></li>
              <li><Link to="/greeting-cards">Greeting Cards</Link></li>
              <li><Link to="/spin-wheels">Spin Wheels</Link></li>
              <li><Link to="/spin-wheels/number-spinner">Number Spinner</Link></li>
              <li><Link to="/spin-wheels/month-spinner">Month Spinner</Link></li>
              <li><Link to="/spin-wheels/truth-or-dare-spinner">Truth or Dare</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><Link to="/help">Help & FAQ</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-left">
              <p>&copy; 2025 Timepass Game. All rights reserved.</p>
            </div>
            <div className="footer-center">
              <VisitorCounter />
            </div>
            <div className="footer-right">
              <div className="footer-links">
                <Link to="/privacy-policy">Privacy</Link>
                <span>•</span>
                <Link to="/terms-of-service">Terms</Link>
                <span>•</span>
                <Link to="/contact">Contact</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
